import React from "react";

const Planner = () => {
  return <div>Planner</div>;
};

export default Planner;
